export const SORT_OPTIONS = {
  dateAsc: { text: 'Newest to Oldest', value: 'desc', key: 'dateDesc' },
  dateDesc: { text: 'Oldest to Newest', value: 'asc', key: 'dateAsc' },
  nameAsc: { text: 'Name A-Z', value: 'asc', key: 'nameAsc' },
  nameDesc: { text: 'Name Z-A', value: 'desc', key: 'nameDesc' },
  statusAsc: { text: 'Status', value: 'asc', key: 'statusAsc' },
}
